import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchBar from '../search/search-bar';
import { withStyles } from '@material-ui/core/styles';
import PenIcon from '@material-ui/icons/CreateOutlined';
import PhotoIcon from '@material-ui/icons/AddAPhotoOutlined';
import VideoIcon from '@material-ui/icons/VideocamOutlined';
import ContentIcon from '@material-ui/icons/ClassOutlined';
import ThumbUpIcon from '@material-ui/icons/ThumbUpOutlined';
import CommentIcon from '@material-ui/icons/CommentOutlined';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import FaceIcon from '@material-ui/icons/Face';
import moment from 'moment';
import Youtube from 'react-youtube';
import Notification from './notification';

class NotificationCenter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      commentSectionOpen: false,
    };
  }

  componentWillMount() {

  }

  handleOnNotificationSelected = (notification) => {
    this.props.history.push(`/socialwall/${notification.linkId}`);
    this.handleUpdateStateForNotification(notification);
  }

  handleUpdateStateForNotification = (notification) => {
    const entry = {
      id: notification.id,
      state: 'Opened',
    };

    this.props.updateState([entry]);
    this.props.setNotificationStates([entry]);
  }

  render() {
    const { classes } = this.props;

    const textStyle = {
      paddingTop: 10,
      paddingBottom: 5,
      paddingLeft: 20,
      paddingRight: 20,
      fontWeight: 'bold',
    };

    const entriesNotSeen =
          this.props.notifications
              .filter(f => f.state === 'New')
              .map(n =>
                <Notification
                  notification={n}
                  handleOnNotificationSelected={this.handleOnNotificationSelected}
                />);

    const entriesSeen =
          this.props.notifications
              .filter(f => f.state !== 'New')
              .map(n =>
                <Notification
                  notification={n}
                  handleOnNotificationSelected={this.handleOnNotificationSelected}
                />);

    return (
      <div>
        <Typography className={classes.titleStyle}>Benachrichtigungen</Typography>
        <Typography style={textStyle}>Neu</Typography>
        <div style={{ flex: 1 }}>
          {entriesNotSeen}
        </div>

        <div style={{ flex: 1 }}>
          <Typography style={textStyle}>Gesehen</Typography>
          {entriesSeen}
        </div>
      </div>

    );
  }
}

NotificationCenter.propTypes = {
  history: PropTypes.any,
  updateState: PropTypes.func,
  setNotificationStates: PropTypes.func,
  classes: PropTypes.object.isRequired,
  notifications: PropTypes.array,
};

NotificationCenter.defaultProps = {
  history: null,
  notifications: [],
  updateState: () => {},
  setNotificationStates: () => {},
}

const styles = theme => ({
  titleStyle: {
    fontSize: 16,
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
});

export default withStyles(styles)(NotificationCenter);



// WEBPACK FOOTER //
// ./src/app/main/notification-center/notification-center.js